import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccessibilityModule } from '@fgb/portal-component-library/accessibility';
import { NotificationModule } from '@fgb/portal-component-library/src/lib/club/notification';
import { CartItemModule } from '@fgb/portal-component-library/src/lib/loyalty/cart-item';
import { LanguageSelectorModule } from '@fgb/portal-component-library/src/lib/shared/language-selector';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClubModule } from '../club/club.module';
import { UserModule } from '../user/user.module';
import { AccountNavComponent } from './components/account-nav/account-nav.component';
import { FloatingCartButtonComponent } from './components/floating-cart-button/floating-cart-button.component';
import { FooterComponent } from './components/footer/footer.component';
import { GameNavComponent } from './components/game-nav/game-nav.component';
import { MixedLoyaltyNavComponent } from './components/mixed-loyalty-nav/mixed-loyalty-nav.component';
import { MobileNavMenuComponent } from './components/mobile-nav-menu/mobile-nav-menu.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NavigationIndicatorComponent } from './components/navigation-indicator/navigation-indicator.component';
import { PaymentNavComponent } from './components/payment-nav/payment-nav.component';
import { PopupNotificationComponent } from './components/popup-notification/popup-notification.component';
import { TicketNavComponent } from './components/ticket-nav/ticket-nav.component';
import { BannerComponent } from './components/banner/banner.component';
import { LeaderboardNavComponent } from './components/leaderboard-nav/leaderboard-nav.component';
import { FantasyNavComponent } from './components/fantasy-nav/fantasy-nav.component';

@NgModule({
  declarations: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    PaymentNavComponent,
    AccountNavComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    BannerComponent,
    LeaderboardNavComponent,
    FantasyNavComponent,
  ],
  exports: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    PaymentNavComponent,
    AccountNavComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    BannerComponent,
    LeaderboardNavComponent,
    FantasyNavComponent,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    SharedModule,
    UserModule,
    ClubModule,
    LanguageSelectorModule,
    LoyaltyIconModule,
    CartItemModule,
    AccessibilityModule,
    NotificationModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
})
export class LayoutModule {}
